import { render, staticRenderFns } from "./rightIndex.vue?vue&type=template&id=5557526a&scoped=true&"
import script from "./rightIndex.vue?vue&type=script&lang=js&"
export * from "./rightIndex.vue?vue&type=script&lang=js&"
import style0 from "./rightIndex.vue?vue&type=style&index=0&id=5557526a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5557526a",
  null
  
)

export default component.exports